(function () {
  document.querySelectorAll('[data-hiw-poster]').forEach(function (poster) {
    if (poster.dataset.initialized) return;
    poster.dataset.initialized = 'true';
    var player = document.getElementById(poster.getAttribute('aria-controls'));
    if (!player) return;
    if (player.tagName !== 'VIDEO') {
      poster.addEventListener('click', function () {
        var source = new URL(player.dataset.hiwEmbedBase);
        source.searchParams.set('autoplay', '1');
        player.src = source.href;
        player.removeAttribute('tabindex');
        poster.hidden = true;
        player.focus({ preventScroll: true });
      });
      return;
    }

    var started = false;
    var resumeWhenVisible = false;
    var visibilityPause = false;
    player.muted = true;
    player.addEventListener('play', function () {
      started = true;
      poster.hidden = true;
    });
    player.addEventListener('pause', function () {
      if (!visibilityPause) resumeWhenVisible = false;
    });
    player.addEventListener('error', function () {
      poster.hidden = false;
    });
    poster.addEventListener('click', function () {
      player.muted = false;
      player.play().catch(function () { poster.hidden = false; });
      player.focus({ preventScroll: true });
    });

    if (!('IntersectionObserver' in window)) return;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if ((!started && !reducedMotion.matches) || resumeWhenVisible) {
            resumeWhenVisible = false;
            player.play().catch(function () { poster.hidden = false; });
          }
        } else if (!player.paused) {
          resumeWhenVisible = true;
          visibilityPause = true;
          player.pause();
          setTimeout(function () { visibilityPause = false; }, 0);
        }
      });
    }, { threshold: 0.35 });
    observer.observe(player);
  });
})();
